import { useEffect, useState } from "react";
import COUPONS from "../api/services/COUPONS";
import Loader from "../components/loader";
import Table from "../containers/_coupons/table";
import Layout from "../layouts/layout";
import styles from "../styles/_screens/coupons.module.scss";
import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import { TagSvg } from "../svgs/tagSvg";
import SideMenu from "../components/sideMenu";

const Coupons = () => {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [responseStatus, setResponseStatus] = useState(null);
  const navigate = useNavigate();

  // FETCH COUPONS
  useEffect(() => {
    setResponseStatus(null);
    const fetchData = async () => {
      try {
        const res = await COUPONS.get_coupons(page, size);
        if (page === 1) {
          setData(res.coupons);
        } else {
          setData((prev) => [...prev, ...res.coupons]);
        }
        setTotalPages(res.totalPages);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [responseStatus, page, size]);

  const sideMenuList = [
    {
      id: 1,
      svg: <TagSvg fill="#DE1468" />,
      text: "קופונים",
      active: true,
    },
    {
      id: 2,
      svg: <TagSvg fill="#000000" />,
      text: "היסטוריית שימוש",
      active: false,
      onClick: () => navigate(paths.couponsUsageHistory),
    },
  ];

  if (!data) {
    return (
      <Layout>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <div className={styles.main}>
              <Loader />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          {/* SIDE MENU */}
          <SideMenu list={sideMenuList} />
          <div className={styles.main}>
            <Table data={data} setResponseStatus={setResponseStatus} />
            {page < totalPages && (
              <button className={styles.button} onClick={() => setPage((prev) => prev + 1)}>
                load more
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Coupons;
